import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, AlertCircle, XCircle } from 'lucide-react';

export default function EscanEatScore({ score, trafficLight, size = 'large' }) {
  const config = {
    green: {
      icon: CheckCircle2,
      color: 'text-emerald-600',
      bg: 'bg-emerald-50',
      border: 'border-emerald-200',
      gradient: 'from-emerald-500 to-green-500',
      label: 'Recomendado',
    },
    yellow: {
      icon: AlertCircle,
      color: 'text-amber-600',
      bg: 'bg-amber-50',
      border: 'border-amber-200',
      gradient: 'from-amber-500 to-orange-500',
      label: 'Moderar',
    },
    red: {
      icon: XCircle,
      color: 'text-red-600',
      bg: 'bg-red-50',
      border: 'border-red-200',
      gradient: 'from-red-500 to-rose-500',
      label: 'No recomendado',
    },
  };

  const currentConfig = config[trafficLight] || config.yellow;
  const Icon = currentConfig.icon;

  if (size === 'small') {
    return (
      <div className={`inline-flex items-center gap-2 px-3 py-1.5 rounded-full ${currentConfig.bg} ${currentConfig.border} border`}>
        <Icon className={`w-4 h-4 ${currentConfig.color}`} />
        <span className={`font-semibold text-sm ${currentConfig.color}`}>
          {score}
        </span>
      </div>
    );
  }

  return (
    <motion.div
      initial={{ scale: 0.9, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      className={`relative rounded-2xl p-6 border-2 ${currentConfig.bg} ${currentConfig.border}`}
    >
      {/* Background circle decoration */}
      <div className={`absolute top-0 right-0 w-32 h-32 rounded-full bg-gradient-to-br ${currentConfig.gradient} opacity-10 blur-2xl`} />
      
      <div className="relative flex items-center gap-4">
        <div className={`w-16 h-16 rounded-xl bg-gradient-to-br ${currentConfig.gradient} flex items-center justify-center`}>
          <Icon className="w-8 h-8 text-white" />
        </div>
        
        <div className="flex-1">
          <div className="flex items-baseline gap-2">
            <span className={`text-4xl font-bold ${currentConfig.color}`}>
              {score}
            </span>
            <span className="text-gray-400">/100</span>
          </div>
          <p className={`text-sm font-medium ${currentConfig.color} mt-1`}>
            {currentConfig.label}
          </p>
        </div>
      </div>

      {/* Progress bar */}
      <div className="mt-4 h-2 bg-white/50 rounded-full overflow-hidden">
        <motion.div
          className={`h-full bg-gradient-to-r ${currentConfig.gradient}`}
          initial={{ width: 0 }}
          animate={{ width: `${score}%` }}
          transition={{ duration: 1, ease: "easeOut" }}
        />
      </div>
    </motion.div>
  );
}